import { useQuery } from '@tanstack/react-query';
import { GetUserPlanQuery } from '../API';
import { getAllUserPlans } from '../services/users';

const useGetAllUserPlans = (userId: string | undefined, active = true) => {
  const { isLoading, data } = useQuery(['user-plans', userId], async () => await getAllUserPlans(userId as string, active), { enabled: !!userId });

  return {
    isLoading,
    data: data as GetUserPlanQuery['getUserPlan'][],
  };
};

export default useGetAllUserPlans;
